import React from 'react'

function Data() {
  return (
   <div className="home__data">
    <h1 className="home__title">SUJITH S
 
    </h1>
    <h3 className="home__subtitle">MERN Stack Developer</h3>
    <p className="home__description">As an MERN Stack developer, i'm proficient in building web applications using some of the most popular and powerful technologies available in the web development landscape.</p>
    
   </div>

  )
}

export default Data